(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1927],{

/***/ 1798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ wilco_quest; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(85495);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(76942);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(93468);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/WilcoQuest/components/Hero/Hero.tsx










var copy = {
  heading: "Wilco can teach you how to implement Segment",
  description: "Sometimes the best way to learn a new skill is to try it out firsthand. Come see how Wilco can provide you with an easy way to experiment with Segment!",
  cta: {
    text: "Get started",
    url: "https://app.wilco.gg/company/Twilio/Segment/play"
  }
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z // eslint-disable-next-line camelcase
          , {
            additionalParams: {
              twilio_developer_offer: "1"
            },
            href: copy.cta.url,
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: copy.cta.text,
                targetUrl: copy.cta.url
              });
            },
            children: copy.cta.text
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "600",
            height: "640",
            src: (Hero_2x_default()),
            alt: "Wilco Integration",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "emxsprn1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "emxsprn0"
} : 0)(recipes_Hero/* Wrapper */.im, "{align-items:start;padding-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/NoBadData/assets/QuestThumbnail@2x.png
var QuestThumbnail_2x = __webpack_require__(36604);
var QuestThumbnail_2x_default = /*#__PURE__*/__webpack_require__.n(QuestThumbnail_2x);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/NoBadData/assets/QuestThumbnail.webp
var QuestThumbnail = __webpack_require__(46970);
var QuestThumbnail_default = /*#__PURE__*/__webpack_require__.n(QuestThumbnail);
// EXTERNAL MODULE: ./src/views/WilcoQuest/components/NoBadData/assets/QuestThumbnail@2x.webp
var assets_QuestThumbnail_2x = __webpack_require__(22680);
var assets_QuestThumbnail_2x_default = /*#__PURE__*/__webpack_require__.n(assets_QuestThumbnail_2x);
;// CONCATENATED MODULE: ./src/views/WilcoQuest/components/NoBadData/NoBadData.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var NoBadData = function NoBadData() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((QuestThumbnail_default()), ", ").concat((assets_QuestThumbnail_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          width: "600",
          height: "640",
          src: (QuestThumbnail_2x_default()),
          alt: "Wilco Quest Thumbnail",
          loading: "lazy"
        })]
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "etxrrs11"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "etxrrs10"
} : 0)( true ? {
  name: "1w52kv1",
  styles: "max-width:1440px"
} : 0);

/* harmony default export */ var NoBadData_NoBadData = (NoBadData);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
;// CONCATENATED MODULE: ./src/views/WilcoQuest/components/Encouragement/Encouragement.tsx


function Encouragement_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Encouragement_copy = {
  sections: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
    children: "We recognize that learning Segment can be a bit daunting if you don\u2019t already have a fully-functioning website or application source to connect."
  }, "copy-section-1"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
    children: "\u2026But what if you did?"
  }, "copy-section-2"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
    children: "We\u2019ve partnered with Wilco to create a fully interactive experience where you learn to use Segment in a very realistic fashion: by actually implementing it in an example application! This isn\u2019t a tour or a simulation\u2014you\u2019ll use an actual (free) Segment workspace and Wilco\u2019s unique, fun \u201Cquest\u201D structure to walk through an implementation of Segment events in a website. In this quest, you\u2019ll use GitHub pull requests to make changes to a real application and make data travel from the website, to Segment, to a destination application. The skills you gain are directly transferable to your production implementation!"
  }, "copy-section-3"), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
    children: ["\u2026and while you\u2019re there, check out the other educational offerings by Wilco. They have a growing library of quests where you can learn to use specific tools and skillsets. ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
      children: "Never stop learning!"
    })]
  }, "copy-section-4")],
  cta: "Get started",
  href: "https://app.wilco.gg/company/Twilio/Segment/play"
};

var Encouragement = function Encouragement() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Encouragement_StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Encouragement_StyledSectionContents, {
      children: [Encouragement_copy.sections.map(function (text) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pMedium",
          children: text
        }, text.key);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          href: Encouragement_copy.href,
          target: "_blank",
          variant: "filled",
          color: "primary",
          size: "large",
          children: Encouragement_copy.cta
        })
      })]
    })
  });
};

var Encouragement_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1xrats2"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;}" + ( true ? "" : 0));

var Encouragement_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1xrats1"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xrats0"
} : 0)( true ? {
  name: "1j6je8b",
  styles: "width:100%;display:flex;justify-content:center;padding-top:42px"
} : 0);

/* harmony default export */ var Encouragement_Encouragement = (Encouragement);
// EXTERNAL MODULE: ./src/views/WilcoQuest/assets/OgImage.png
var OgImage = __webpack_require__(47110);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/WilcoQuest/WilcoQuest.tsx













var WilcoQuest = function WilcoQuest() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioDark",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Wilco Quest | Twilio Segment",
      pageDescription: "Introducing a partnership between Twilio Segment & Wilco, where you can learn how to use Segment by using it, in a guided, interactive manner!`",
      pageOG: (OgImage_default()),
      themeColor: theme.palette.twilio.gray[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {
        backgroundColor: theme.palette.twilio.gray[100]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoBadData_NoBadData, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Encouragement_Encouragement, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1d3c0880"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var WilcoQuest_WilcoQuest = (WilcoQuest);
;// CONCATENATED MODULE: ./src/pages/wilco-quest/index.tsx



var wilco_quest_WilcoQuest = function WilcoQuest() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WilcoQuest_WilcoQuest, {});
};

/* harmony default export */ var wilco_quest = (wilco_quest_WilcoQuest);

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx







var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 95309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wilco-quest",
      function () {
        return __webpack_require__(1798);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47110:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-72bccd290817834f3d2137c2e1be3576.png";

/***/ }),

/***/ 85495:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-9b0537cd986b20285207e3dfc4e19733.png";

/***/ }),

/***/ 36604:
/***/ (function(module) {

module.exports = "/_next/static/images/QuestThumbnail@2x-5f3ee15fadc23c6458902f14f57b2cff.png";

/***/ }),

/***/ 76942:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-6eccde064bf08a2b161c998598792032.webp";

/***/ }),

/***/ 93468:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-e0b5786f0f08ef1b0cf3d9a829815607.webp";

/***/ }),

/***/ 46970:
/***/ (function(module) {

module.exports = "/_next/static/images/QuestThumbnail-147d1ab69cc6eeb0c05c2882e477512a.webp";

/***/ }),

/***/ 22680:
/***/ (function(module) {

module.exports = "/_next/static/images/QuestThumbnail@2x-21e5796afa0003488944a1c171de52f7.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,1382,4136,8392,2073,2429,9524,9774,2888,179], function() { return __webpack_exec__(95309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);